import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import withRouter from 'react-router/withRouter';
import loadData from './tag_page_state_manager';
import FeatureFeed from '../../../components/feature_feed/feature_feed';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import VideoModule from '../../../components/video_module/video_module';
import AllFeed from '../../../components/all_feed/all_feed';
import Advertorial, {
  isAdvertorial
} from '../../../components/advertorial/advertorial';
import { tagAllFeedAllStoriesRendered } from '../../../../redux/action_creators/tag/tag_all_feed_action_creators';

// eslint-disable-next-line react/prefer-stateless-function
class Tag extends Component {
  static loadData(store, override) {
    return loadData(store, override);
  }

  render() {
    if (this.props.tagPage.error || this.props.tagFeaturedFeed.error) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.tagPage.isLoading) {
      return (
        <section className="tag-page">
          <article className="tag-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { tagPage, config, tagFeaturedFeed, tagAllFeed } = this.props;
    const adData = get(tagPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgName = get(tagFeaturedFeed, 'tag.name');
    const pgDesc = get(tagFeaturedFeed, 'tag.description');
    const tags = get(tagAllFeed, 'posts[0].tags');
    const advertorial = isAdvertorial(tags);
    const page = get(this.props, 'match.params.page', false);
    const totalPages = get(this.props, 'tagAllFeed.totalPages');
    let isLastPage = Number(page) === totalPages;

    if (!page) {
      if (totalPages === 1) {
        isLastPage = true;
      }
      return (
        <section
          className={`tag-page ${advertorial ? 'tag-page--advertorial' : ''}`}
        >
          <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />

          {advertorial ? (
            <Advertorial
              modifier="tag-page"
              tags={tags}
              adModel={combinedAdModel}
            />
          ) : (
            ''
          )}
          {advertorial ? (
            <AllFeed
              adModel={combinedAdModel}
              stories={get(this.props, 'tagAllFeed.posts')}
              allRendered={get(this.props, 'tagAllFeed.allRendered')}
              updateAction={tagAllFeedAllStoriesRendered}
              config={config}
              tags={get(this.props, 'tagAllFeed.posts[0].tags')}
              advertorialSlugs={get(this.props, 'tagFeaturedFeed.tag')}
              modifier="advertorial"
            />
          ) : (
            <div>
              <section className="page-title">
                <Slug slugName={pgName} className="tag-page" />
                {pgDesc ? (
                  <h3
                    className="page-description"
                    dangerouslySetInnerHTML={{ __html: pgDesc }}
                  />
                ) : (
                  ''
                )}
              </section>

              <FeatureFeed
                featuredFeed={this.props.tagFeaturedFeed}
                promoBanner={this.props.tagPromoBanner}
                scrollingModule={this.props.tagScrollingModule}
                combinedAdModel={combinedAdModel}
                config={config}
                page="tag"
                featuredSponsoredCard={this.props.featuredSponsoredCard}
              />

              {get(this.props, 'tagFeaturedFeed.top.length') >= 2 ? (
                <div className="tag-page__ff-ad-container">
                  <Ad {...combinedAdModel} name="flexiblebillboard_2" />
                  <Ad {...combinedAdModel} name="mobilerectangle_1" />
                </div>
              ) : (
                ''
              )}

              <VideoModule
                config={config}
                type="tag"
                data={this.props.tagVideo}
                playerid="HliaKwd3"
                stories={this.props.tagVideo.playlist}
              />

              {get(this.props, 'tagFeaturedFeed.top.length') ? (
                <div className="tag-page__ff-ad-container">
                  <Ad {...combinedAdModel} name="flexiblebillboard_2" />
                  <Ad {...combinedAdModel} name="mobilerectangle_1" />
                </div>
              ) : (
                ''
              )}

              <AllFeed
                adModel={combinedAdModel}
                stories={get(this.props, 'tagAllFeed.posts')}
                allRendered={get(this.props, 'tagAllFeed.allRendered')}
                updateAction={tagAllFeedAllStoriesRendered}
                config={config}
                paginationEnabled={true}
                page={Number(get(this.props, 'match.params.page', '1')) + 1}
                section={get(this.props, 'match.params.tag')}
                type="section"
                isLastPage={isLastPage}
                titleOverride={`All ${pgName} Stories`}
              />
            </div>
          )}

          {get(this.props, 'tagVideo.playlist.length') ? (
            <div className="tag-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_3" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          ) : (
            ''
          )}
        </section>
      );
    }
    return (
      <section className="tag-page">
        <section className="page-title page-title--paginated">
          <Slug slugName={pgName} className="tag-page" />
          {pgDesc ? <h3 className="page-description">{pgDesc}</h3> : ''}
        </section>
        <AllFeed
          hasSlug={false}
          adModel={combinedAdModel}
          stories={get(this.props, 'tagAllFeed.posts')}
          allRendered={get(this.props, 'tagAllFeed.allRendered')}
          updateAction={tagAllFeedAllStoriesRendered}
          config={config}
          paginationEnabled={true}
          page={Number(get(this.props, 'match.params.page', '1')) + 1}
          section={get(this.props, 'match.params.tag')}
          type="section"
          isLastPage={isLastPage}
        />

        {get(this.props, 'tagAllFeed.posts.length') ? (
          <div className="tag-page__all-ad-container">
            <Ad {...combinedAdModel} name="flexiblebillboard_5" />
            <Ad {...combinedAdModel} name="mobileparallax_2" />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    featuredSponsoredCard: get(state, 'featuredSponsoredCard.data') || {},
    tagFeaturedFeed: {
      featured: get(state, 'tagFeaturedFeed.featured') || [],
      top: get(state, 'tagFeaturedFeed.top') || [],
      tag: get(state, 'tagFeaturedFeed.tag') || {},
      source: get(state, 'tagFeaturedFeed.source') || '',
      error: get(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: get(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: get(state, 'tagPage') || { error: true },
    tagScrollingModule: get(state, 'tagScrollingModule.data') || {},
    tagPromoBanner: get(state, 'tagPromoBanner.data') || {},
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    }
    // scrollingModule: get(state, 'scrollingModule.data.posts') || []
  };
}

Tag.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tagPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  tagFeaturedFeed: PropTypes.shape({
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    tag: PropTypes.object,
    source: PropTypes.string,
    error: PropTypes.bool
  }).isRequired,
  tagVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  tagScrollingModule: PropTypes.shape({}).isRequired,
  tagPromoBanner: PropTypes.shape({}).isRequired,
  featuredSponsoredCard: PropTypes.shape({}).isRequired,
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool,
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(Tag));
